export const COLORS = [
  'var(--presence-raw-red)',
  'var(--presence-raw-yellow)',
  'var(--presence-raw-green)',
  'var(--presence-raw-cyan)',
  'var(--presence-raw-blue)',
  'var(--presence-raw-purple)',
  'var(--presence-raw-pink)',
]

export const getSolidColor = (color: string) => {
  return color.replace('-raw', '')
}

export const getBackgroundColor = (color: string) => {
  return `rgb(${color} / ${color.replace('raw', 'opacity')})`
}
